var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("custom-drop-down", {
          staticClass: "custom-drop-down__extended",
          attrs: {
            clearable: false,
            fieldkey: "year",
            fieldname: "description",
            label: "Año Académico:",
            options: _vm.catalog.academicYears
          },
          on: { input: _vm.onChangeAcademicYearHandler },
          model: {
            value: _vm.model.academicYear,
            callback: function($$v) {
              _vm.$set(_vm.model, "academicYear", $$v)
            },
            expression: "model.academicYear"
          }
        }),
        _c("hr")
      ],
      1
    ),
    _c(
      "div",
      [
        !_vm.hasVendorInfo && _vm.model.academicYear
          ? _c(
              "custom-callout",
              {
                attrs: {
                  "border-color": "primary-1",
                  "class-main": "py-3",
                  "has-border": false,
                  "has-toggle": false
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "row d-flex justify-content-center" },
                  [
                    _c("action-button", {
                      staticClass: "border w-40 btn",
                      attrs: {
                        i: "fas fa-list color-primary-1",
                        text: _vm.searchButtonText
                      },
                      on: { click: _vm.onSyncAndGetVendorInfo }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm.hasVendorInfo
      ? _c(
          "div",
          [
            _c("general-info", {
              staticClass: "mt-4",
              attrs: { value: _vm.data.vendorInfo || {} },
              on: { "on-update-vendor": _vm.onSyncAndGetVendorInfo }
            }),
            _c("contract-info", {
              staticClass: "mt-5",
              attrs: { value: _vm.data.contractInfo || {} },
              on: { "on-update-po": _vm.onUpdatePoHandler }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }